import { render } from "./ScheduledDelivery.vue?vue&type=template&id=c24f619e&scoped=true"
import script from "./ScheduledDelivery.vue?vue&type=script&lang=js"
export * from "./ScheduledDelivery.vue?vue&type=script&lang=js"

import "./ScheduledDelivery.vue?vue&type=style&index=0&id=c24f619e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24f619e"]])

export default __exports__